import { HourlyRequiredEmployeePrediction, } from './HourlyRequiredEmployeePrediction';

/**
 * A class defines hourly required employee predictions for a specific date.
 */
export class DailyRequiredEmployeePrediction {
  date: string;
  hourlyPredictions: HourlyRequiredEmployeePrediction[];

  /**
   * @param date the date of required employee predictions.
   * @param hourlyPredictions required employee predictions for each hour.
   */
  constructor(date: string, hourlyPredictions: HourlyRequiredEmployeePrediction[]) {
    this.date = date;
    this.hourlyPredictions = hourlyPredictions;
  }
}
